(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  function initialize(root = document) {
    root.querySelectorAll('[data-cc-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('[data-cc-video-toggle]');
      const sources = JSON.parse(hero.querySelector('[data-cc-video-sources]').textContent);
      let paused = false;
      const sync = () => {
        video.pause(); video.replaceChildren(); video.removeAttribute('src'); video.load();
        video.hidden = true; toggle.hidden = true;
        if (reduce.matches) return;
        const chosen = mobile.matches ? sources.mobile : sources.desktop;
        const available = chosen.filter(source => source.src && video.canPlayType(source.type));
        if (!available.length) return;
        available.forEach(item => { const source = document.createElement('source'); source.src = item.src; source.type = item.type; video.append(source); });
        video.muted = true; video.load();
        if (!paused) video.play().catch(() => { video.hidden = true; });
      };
      video.addEventListener('playing', () => { video.hidden = false; toggle.hidden = false; toggle.textContent = toggle.dataset.pause; });
      video.addEventListener('pause', () => { toggle.textContent = toggle.dataset.play; });
      video.addEventListener('error', () => { video.hidden = true; toggle.hidden = true; });
      toggle.addEventListener('click', () => { paused = !video.paused; paused ? video.pause() : video.play().catch(() => {}); });
      reduce.addEventListener('change', sync); mobile.addEventListener('change', sync); sync();
    });
    root.querySelectorAll('[data-cc-loop]').forEach(wrapper => {
      if (wrapper.dataset.ready) return;
      wrapper.dataset.ready = 'true';
      const video = wrapper.querySelector('video');
      const toggle = wrapper.querySelector('[data-cc-video-toggle]');
      let paused = false;
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !reduce.matches && !paused) video.play().catch(() => {});
        else video.pause();
      }, { threshold: .5 });
      observer.observe(video);
      reduce.addEventListener('change', () => { if (reduce.matches) video.pause(); });
      video.addEventListener('playing', () => toggle.textContent = toggle.dataset.pause);
      video.addEventListener('pause', () => toggle.textContent = toggle.dataset.play);
      toggle.addEventListener('click', () => { paused = !video.paused; paused ? video.pause() : video.play().catch(() => {}); });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
